import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 766.000000 710.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,710.000000) scale(0.100000,-0.100000)"
        >
         <path d="M3812 5761 c-12 -16 -73 -134 -135 -263 -189 -385 -467 -947 -595
-1205 -67 -134 -117 -243 -112 -243 10 0 143 52 195 75 17 8 66 25 110 38 254
77 383 92 659 77 228 -13 355 -35 496 -87 52 -19 100 -39 105 -43 18 -13 136
-53 141 -48 3 3 -37 90 -88 194 -52 104 -115 234 -140 289 -78 166 -607 1245
-612 1245 -1 0 -12 -13 -24 -29z"/>
<path d="M3400 5529 c-314 -64 -569 -169 -810 -336 -296 -206 -564 -512 -723
-829 -148 -295 -219 -565 -243 -924 -15 -244 54 -627 167 -915 40 -103 123
-255 138 -255 5 0 44 71 86 158 l78 157 -51 150 c-79 231 -111 415 -112 632 0
416 139 831 389 1153 261 337 593 560 1011 679 20 5 40 36 97 146 40 77 76
152 82 168 10 26 9 27 -27 26 -20 -1 -57 -5 -82 -10z"/>
<path d="M4150 5526 c0 -15 24 -69 103 -237 l37 -76 57 -17 c381 -112 735
-346 966 -641 26 -33 52 -66 57 -72 6 -7 38 -57 72 -110 118 -188 205 -402
254 -625 32 -151 44 -445 24 -604 -13 -107 -59 -301 -88 -379 -11 -27 -29 -76
-42 -108 -13 -36 -19 -68 -16 -83 8 -31 133 -285 147 -299 27 -26 117 144 183
345 46 142 96 361 117 520 26 196 10 508 -37 700 -124 506 -354 887 -729 1206
-302 257 -690 437 -1057 489 -40 6 -48 5 -48 -9z"/>
<path d="M3680 3968 c-107 -7 -165 -19 -345 -70 -87 -25 -199 -75 -335 -151
-205 -114 -232 -142 -330 -342 -43 -88 -191 -389 -329 -669 -138 -280 -251
-511 -251 -513 0 -1 196 -3 435 -3 l435 0 165 336 c91 186 165 342 165 348 0
6 -16 34 -36 61 l-35 50 28 23 c15 12 52 37 82 55 86 52 97 65 160 206 l60
133 -37 -6 c-60 -11 -291 -132 -365 -191 -38 -30 -75 -55 -82 -55 -8 0 -22 15
-31 32 -10 18 -44 61 -77 95 l-60 62 60 58 c61 60 185 141 288 188 127 57 366
125 442 125 26 0 33 8 69 83 43 86 61 142 47 149 -4 2 -60 0 -123 -4z"/>
<path d="M3848 3958 c7 -9 32 -60 57 -114 l44 -99 97 -12 c214 -27 465 -138
657 -290 37 -30 67 -58 67 -64 0 -5 -27 -38 -59 -72 -33 -34 -70 -74 -83 -89
-24 -29 -52 -36 -64 -17 -12 19 -187 130 -260 164 -75 35 -174 68 -182 60 -3
-2 22 -63 54 -136 53 -118 63 -134 106 -165 27 -19 50 -34 53 -34 11 0 105
-72 105 -81 0 -5 -15 -29 -34 -54 l-35 -45 24 -55 c14 -30 29 -63 35 -72 5
-10 36 -74 69 -143 125 -266 153 -326 174 -367 l22 -42 433 -6 c237 -4 432 -5
432 -2 0 5 -146 304 -474 972 -103 209 -199 393 -214 409 -32 33 -117 93 -193
134 -30 16 -83 45 -119 65 -82 45 -138 65 -320 116 -119 33 -168 41 -275 47
-115 6 -128 5 -117 -8z"/>
<path d="M4990 1983 c-40 -28 -47 -37 -64 -87 -34 -100 -24 -138 83 -329 23
-41 31 -65 27 -82 -9 -35 -47 -42 -96 -16 l-40 21 0 -85 0 -84 38 -10 c49 -14
108 -14 135 1 54 28 87 94 87 173 0 67 -18 119 -73 203 -51 79 -62 112 -43
137 13 18 58 18 100 0 18 -8 18 -4 12 71 -5 54 -13 83 -24 92 -24 18 -113 15
-142 -5z"/>
<path d="M1797 1983 c-3 -5 -10 -28 -17 -53 -33 -123 -170 -602 -175 -611 -4
-5 22 -9 64 -9 l70 0 22 95 21 95 63 0 63 0 10 -47 c6 -27 13 -69 17 -95 l7
-48 64 0 c35 0 64 1 64 3 0 2 -27 138 -59 303 -32 164 -62 316 -65 337 l-7 37
-69 0 c-38 0 -71 -3 -73 -7z m78 -245 c3 -29 9 -61 11 -70 4 -15 -1 -18 -30
-18 -20 0 -36 3 -36 6 0 19 35 134 41 134 4 0 10 -24 14 -52z"/>
<path d="M2106 1773 c-3 -120 -9 -273 -13 -340 l-6 -123 147 0 147 0 -3 77 -3
76 -77 -2 -78 -2 1 98 c1 54 4 173 8 266 l6 167 -61 0 -61 0 -7 -217z"/>
<path d="M2427 1983 c-4 -3 -7 -97 -8 -207 -1 -111 -4 -261 -8 -334 l-6 -132
63 0 62 0 0 58 c0 31 3 108 7 170 l6 113 44 -133 c24 -73 48 -150 54 -171 l10
-38 126 3 127 3 13 55 c8 30 19 72 24 93 l10 37 63 0 64 0 7 -47 c4 -27 11
-69 17 -95 l10 -48 65 0 c58 0 64 2 59 18 -8 26 -113 556 -121 615 l-7 47 -72
0 -72 0 -89 -315 c-49 -173 -93 -311 -97 -307 -12 12 -108 279 -108 300 0 10
29 86 64 170 l64 153 -70 -3 -70 -3 -54 -144 c-30 -80 -57 -147 -60 -150 -3
-3 -2 63 2 147 l7 152 -60 0 c-33 0 -63 -3 -66 -7z m619 -279 l6 -54 -31 0
c-36 0 -36 0 -14 93 15 62 18 67 24 43 4 -16 11 -52 15 -82z"/>
<path d="M3276 1978 c-3 -7 -7 -160 -10 -340 l-6 -328 55 0 55 0 2 153 c2 253
3 255 42 124 16 -50 40 -128 53 -172 14 -44 26 -86 29 -92 2 -9 26 -13 72 -13
l69 0 7 258 c3 141 9 294 12 340 l6 82 -54 0 -55 0 -6 -127 c-4 -71 -7 -162
-7 -203 l-1 -75 -38 125 c-22 69 -49 160 -61 203 l-23 77 -69 0 c-46 0 -70 -4
-72 -12z"/>
<path d="M3828 1933 c-13 -50 -139 -494 -167 -590 l-10 -33 68 0 67 0 12 58
c7 31 17 74 22 95 l11 37 63 0 64 0 11 -67 c23 -135 14 -123 87 -123 58 0 65
2 60 18 -8 24 -113 558 -121 615 l-7 47 -73 0 -73 0 -14 -57z m98 -229 l6 -54
-31 0 c-17 0 -31 3 -31 8 0 4 8 40 17 81 19 81 25 76 39 -35z"/>
<path d="M4134 1958 c3 -18 19 -157 36 -308 17 -151 33 -290 36 -307 l5 -33
68 0 69 0 5 33 c4 17 14 89 23 159 10 70 21 125 24 123 4 -3 13 -74 20 -160
l13 -155 73 0 c71 0 73 1 78 28 11 60 38 207 71 397 19 110 38 213 41 228 l6
28 -58 -3 -59 -3 -35 -215 -36 -215 -7 90 c-4 50 -13 147 -19 218 l-11 127
-63 0 c-74 0 -63 27 -96 -233 -26 -204 -28 -202 -54 56 l-18 177 -59 0 -59 0
6 -32z"/>
<path d="M4736 1698 c-4 -161 -9 -314 -12 -340 l-6 -48 66 0 66 0 0 93 c0 50
3 203 7 340 l6 247 -60 0 -61 0 -6 -292z"/>
<path d="M5217 1863 c-4 -71 -7 -197 -7 -281 0 -133 3 -158 20 -192 29 -58 82
-90 148 -90 93 0 153 43 181 130 8 26 27 356 31 553 0 4 -29 7 -65 7 l-65 0
-1 -122 c0 -68 -4 -176 -8 -240 -9 -135 -24 -171 -69 -166 -50 6 -54 29 -48
291 l6 237 -58 0 -59 0 -6 -127z"/>
<path d="M5636 1678 c-4 -172 -9 -325 -12 -340 l-6 -28 117 0 c142 0 174 12
205 74 38 80 18 251 -32 269 -10 3 -8 9 5 25 45 50 61 176 32 244 -24 59 -48
68 -183 68 l-119 0 -7 -312z m188 166 c19 -7 22 -84 4 -102 -7 -7 -27 -12 -45
-12 l-33 0 0 60 c0 60 0 60 29 60 16 0 36 -3 45 -6z m-6 -260 c19 -6 22 -13
22 -60 0 -59 -17 -78 -68 -72 -26 3 -27 4 -23 63 1 33 5 63 8 68 5 8 30 9 61
1z"/>
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
